/** Event data that marks a camera move whose `moveend` the visible-extent emitter does not report. */
export const SKIP_EXTENT_EMIT = { skipExtentEmit: true } as const;
